import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ClearanceItemComponent, ClearanceListComponent } from './index';
import { PendingChangesGuard, RoleGuard } from '../shared/core/index';
import { ClearanceItemHistoryComponent } from './clearance-item-history.component';
import { CarouselComponent } from './carousel.component';

export const CIRoutes: Routes = [
  {
    path: 'projects/:projectId/items',
    component: ClearanceListComponent,
    canActivate: [RoleGuard], data: {
      roles: [process.env.CLEARANCE_ROLE, process.env.PRODUCTION_ROLE],
      key: 'itemlist'
    },
  },
  {
    path: 'projects/:projectId/items/:ciId',
    component: ClearanceItemComponent,
    canActivate: [RoleGuard], data: {
      roles: [process.env.CLEARANCE_ROLE, process.env.PRODUCTION_ROLE],
      key: 'noflush'
    },
    canDeactivate: [PendingChangesGuard]
  },
  {
    path: 'projects/:projectId/items/:ciId/:assetType/:imageIndex',
    component: ClearanceItemComponent,
    canActivate: [RoleGuard], data: {
      roles: [process.env.CLEARANCE_ROLE, process.env.PRODUCTION_ROLE],
      key: 'noflush'
    },
    canDeactivate: [PendingChangesGuard]
  },
  {
    path: 'projects/:projectId/items/:ciId/history',
    component: ClearanceItemHistoryComponent,
    canActivate: [RoleGuard], data: {
      roles: [process.env.CLEARANCE_ROLE, process.env.PRODUCTION_ROLE],
      key: 'noflush'
    },
  },
  
];

export const ClearanceItemRouting: ModuleWithProviders =
  RouterModule.forChild(CIRoutes);


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/clearance-item/clearance-item.routes.ts